import React from 'react';
import {
  withStyles,
  MuiThemeProvider,
  createTheme,
} from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import NavigateNext from '@material-ui/icons/NavigateNext';
import NavigateBefore from '@material-ui/icons/NavigateBefore';
import Paper from '@material-ui/core/Paper';
import { Link } from 'react-router-dom';
import { object, bool, string, func, number } from 'prop-types';
import LinearProgress from '@material-ui/core/LinearProgress';
import { Translation } from 'react-i18next';

import VisaDetails from '../../forms/Application/VisaDetails';
import PersonalDetails from '../../forms/Application/PersonalDetails';
import PassportDetails from '../../forms/Application/PassportDetails';
import ContactDetails from '../../forms/Application/ContactDetails';

import Footer from '../components/Footer';

const styles = (theme) => ({
  rootContainer: {
    marginTop: theme.spacing(10),
  },
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    [theme.breakpoints.up('sm')]: {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3),
    },
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(5),
  },
  paper: {
    padding: theme.spacing(2),
    height: '100%',
    color: theme.palette.text.secondary,
  },
  control: {
    padding: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  buttonBack: {
    backgroundColor: '#b22a00',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(2),
  },
  buttonBackTo: {
    backgroundColor: '#0280CA',
    color: '#ffffff',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  buttonSave: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    background: '#357a38',
  },
  rightIcon: {
    marginLeft: theme.spacing(1),
  },
  leftIcon: {
    marginRight: theme.spacing(1),
  },
  buttonLeftContainer: {
    display: 'flex',
  },
  buttonRightContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
  },
  progress: {
    flexGrow: 1,
  },
  subPage: {
    marginTop: theme.spacing(2),
  },
  footerContainer: {
    marginTop: theme.spacing(20),
    backgroundColor: '#201F1F',
  },
  footerBar: {
    backgroundColor: '#201F1F',
    padding: theme.spacing(2),
  },
  textFooterTerms: {
    color: '#7C7A7A',
    fontWeight: 'bold',
    marginRight: theme.spacing(2),
  },
  textFooter: {
    color: '#7C7A7A',
    fontWeight: 'bold',
  },
  trademarkText: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
});

const theme = createTheme({
  palette: {
    primary: {
      main: '#6fbf73',
      contrastText: '#ffffff',
    },
    secondary: {
      main: '#f50057',
      contrastText: '#ffffff',
    },
  },
  typography: {
    useNextVariants: true,
  },
});

class ApplicationPage extends React.Component {
  componentDidMount() {
    if (!this.props.isLoaded) this.props.loadData();
  }

  renderComponent = () => {
    const { currentPage } = this.props;
    switch (currentPage) {
      case 1:
        return <VisaDetails />;
      case 2:
        return <PersonalDetails />;
      case 3:
        return <ContactDetails />;
      case 4:
        return <PassportDetails />;
      default:
        break;
    }
  };

  onNext = () => {
    this.props.save(this.props.history);
  };

  render() {
    const { classes, isFetching, goBack, isLAO, currentPage, hasApplications } =
      this.props;
    const initial = currentPage === 1;
    return (
      <Translation>
        {(t) => {
          return (
            <div className={classes.rootContainer}>
              <Grid
                container
                alignItems="center"
                direction="row"
                justifyContent="center"
              >
                <Grid item xs={11}>
                  <Typography variant="h4" align="center" gutterBottom>
                    {t('applicationForm')}
                  </Typography>
                </Grid>
                <Grid item xs={11}>
                  <Paper className={classes.root} elevation={3}>
                    {isFetching && (
                      <LinearProgress className={classes.progress} />
                    )}
                    {this.renderComponent()}
                  </Paper>
                </Grid>
                <Grid container direction="row" justifyContent="space-around">
                  <Grid item xs={5} className={classes.buttonLeftContainer}>
                    {(isLAO || hasApplications) && (
                      <MuiThemeProvider theme={theme}>
                        <Button
                          variant="contained"
                          color="primary"
                          disabled={isFetching}
                          className={classes.buttonBackTo}
                          component={Link}
                          to={'/applications'}
                        >
                          {t('backTo')}
                        </Button>
                      </MuiThemeProvider>
                    )}
                  </Grid>
                  {
                    <Grid item className={classes.buttonRightContainer} xs={5}>
                      {!initial && (
                        <Button
                          variant="contained"
                          color="secondary"
                          onClick={goBack}
                          className={classes.buttonBack}
                          disabled={isFetching}
                        >
                          <NavigateBefore className={classes.leftIcon} />
                          {t('back')}
                        </Button>
                      )}
                      <MuiThemeProvider theme={theme}>
                        <Button
                          variant="contained"
                          color="primary"
                          className={classes.buttonSave}
                          disabled={isFetching}
                          onClick={this.onNext}
                        >
                          {t('saveAndContinue')}
                          <NavigateNext className={classes.rightIcon} />
                        </Button>
                      </MuiThemeProvider>
                    </Grid>
                  }
                </Grid>
              </Grid>

              <Footer />
            </div>
          );
        }}
      </Translation>
    );
  }
}

ApplicationPage.propTypes = {
  classes: object.isRequired,
  isFetching: bool.isRequired,
  isLoaded: bool.isRequired,
  error: string,
  save: func.isRequired,
  loadData: func.isRequired,
  currentPage: number.isRequired,
  goBack: func.isRequired,
  hasApplications: bool.isRequired,
};

export default withStyles(styles)(ApplicationPage);



// WEBPACK FOOTER //
// ./src/view/scenes/Application/Application.js